import type { AuditLogPage, AuditLogQuery } from '@domain/entities';
import type { AuditLogRepository } from '@domain/repositories';

export class SearchAuditLogs {
  constructor(private readonly repo: AuditLogRepository) {}

  execute(query: AuditLogQuery): Promise<AuditLogPage> {
    return this.repo.search(query);
  }
}
